export const types = {
	INIT_DOCUMENTS: "INIT_FORM_34_DOCUMENTS",
	ADD_DOCUMENT: "ADD_FORM_34_DOCUMENT",
	REMOVE_DOCUMENT: "REMOVE_FORM_34_DOCUMENT",
	RESET_DOCUMENTS: "RESET_FORM_34_DOCUMENTS",
}

export const initForm34Docs = (documents) => {
	return (dispatch) => dispatch({
		type: types.INIT_DOCUMENTS,
		payload: documents
	})
}

export const addForm34Doc = (docData) => {
	return (dispatch) => dispatch({
		type: types.ADD_DOCUMENT,
		payload: docData
	})
}

export const removeForm34Doc = (docId) => {
	return (dispatch) => dispatch({
		type: types.REMOVE_DOCUMENT,
		payload: docId
	})
}

export const resetForm34Docs = () => {
	return (dispatch) => dispatch({
		type: types.RESET_DOCUMENTS,
	})
}
